import React from 'react';
import { Box, Container, Grid, Header } from '@amzn/awsui-components-react';
import { LEFReportSummary } from 'src/models/reports/ReportGenerationSummary';
import ReportSummarySection from './ReportSummarySection';

export default function LEFReportSummarySection({ summary }: { summary?: LEFReportSummary }) {
    if (!summary) {
        return (
            <Grid gridDefinition={[{ colspan: { default: 7, xl: 8 } }, { colspan: { default: 5, xl: 4 } }]}>
                <Container header={<Header variant="h2" description="Legal Entity Financial report generation status by company code">LEF Report Status</Header>}>
                    <Box textAlign="center" padding={{ top: "l", bottom: "l" }} color="inherit"><b>No data available</b><Box variant="p" color="inherit">No LEF report status data available to display</Box></Box>
                </Container>
                <Box textAlign="center" padding={{ top: "xxl", bottom: "l" }} color="inherit">
                    <b>No data available</b><Box variant="p" color="inherit">No LEF chart data available</Box>
                </Box>
            </Grid>
        );
    }
    return (
        <ReportSummarySection
            title="LEF Report Status"
            description="Legal Entity Financial report generation status by company code"
            totalLabel="Total Entities"
            totalCount={summary.totalEntities}
            successCount={summary.successCount}
            failureCount={summary.failureCount}
            pendingCount={summary.pendingCount}
            reasonCodeSummary={summary.reasonCodeSummary}
            failedItems={summary.failedEntities.map(e => ({ id: e.entityId, reasonCode: e.reasonCode }))}
            failedItemIdHeader="Entity (Company Code)"
            failedItemsLabel="Failed Entities"
            unitNoun="entity"
            ariaDescription="Donut chart showing LEF report generation status"
            ariaLabel="LEF report status donut chart"
            emptyDataDescription="No LEF report status data available"
            noMatchDataDescription="No LEF data for the selected filter criteria"
        />
    );
}
